import { render, staticRenderFns } from "./DetailTemplates.vue?vue&type=template&id=7fd75830&"
import script from "./DetailTemplates.vue?vue&type=script&lang=js&"
export * from "./DetailTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports